import { Component, Input } from '@angular/core';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { SpeechaceService } from '../../shared/speechace-modal/speechace.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { CourseContentType } from '../../shared/types/course-content-type';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { ImmersionCourseService } from '../../shared/immersion-course.service';
import { StudyBundleCourseStatusType } from '../../shared/types/StudyBundleCourseStatusType';
import { combineLatest, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { PracticeSectionContent } from '../practice-section/practice-section.interface';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';
import { ProfileLiteExtService } from '../../shared/profile-lite-ext.service';
import { ImmersionSortBy } from '../../shared/types/immersion-sort-by';

@Component({
  selector: 'lp2-speechace-carousel',
  templateUrl: './speechace-carousel.component.html',
  styleUrls: ['./speechace-carousel.component.scss'],
})
export class SpeechaceCarouselComponent extends ImmersionCarouselComponent implements PracticeSectionContent {
  showSpeechaceCarousel$ = combineLatest([
    this.profileServiceConfigurationService.isSpeechaceCarouselEnabled$(),
    this.profileService.getPersonData$(),
  ]).pipe(
    map(([isSpeechaceCarouselEnabled, personData]) => isSpeechaceCarouselEnabled && personData.program.speechAceEnabled)
  );

  shouldDisplay$ = combineLatest([
    this.showSpeechaceCarousel$,
    this.itemsLoaded$
  ]).pipe(
    map(([shouldDisplay, hasLoaded]) => shouldDisplay && hasLoaded && (this.immersionItems.length > 0 || this.hasError))
  );

  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.pronunciationPoints = value
      ? value.get(GamificationActivityType.COMPLETE_PRACTICE_PRONUNCIATION)
      : 0;
  }

  pronunciationPoints: number;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  filteredStatuses: string[] = [];

  destroy = new Subject<boolean>();

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService,
    private speechaceService: SpeechaceService,
    private immersionCourseService: ImmersionCourseService,
    private profileServiceConfigurationService: ProfileServiceConfigurationService,
    private profileService: ProfileLiteExtService
  ) {
    super(service, levelProgressService, CourseContentType.PRONUNCIATIONS, ImmersionSortBy.SEQUENCE);
    this.subscription.add(
      this.immersionCourseService.courseSaved.subscribe((id: number) => {
        this.reloadCourseTileById(id);
      })
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.speechaceService.progressReported
      .pipe(takeUntil(this.destroy))
      .subscribe((courseId: number) => {
        this.reloadCourseTileById(courseId);
      });
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }

  openActivity(speechace: StudyBundleCourseDto) {
    this.speechaceService.openActivity(
      speechace.title,
      speechace.id,
      speechace.mediaData,
      speechace.status === StudyBundleCourseStatusType.COMPLETE
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/speechace-carousel/speechace-carousel.component.ts